import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';
import { sharedActions } from './store/actions';

import { messagePropTypes } from './propTypes';

const CommunicationsAdminColumnRenderer = ({
  value,
  rowIndex,
  showModalForAddEdit,
  showModalForRemove,
}) => {
  const showEditModal = useCallback(() => {
    showModalForAddEdit(value);
  }, [showModalForAddEdit, value]);

  const showDeleteModal = useCallback(() => {
    showModalForRemove({ entity: value, rowIndex });
  }, [showModalForRemove, value, rowIndex]);

  return (
    <div>
      <button
        className="cell-icon-button"
        title="Edit Communication"
        onClick={showEditModal}
      >
        <PencilIcon size={16} className="cell-icon" />
      </button>

      <button
        className="cell-icon-button"
        title="Remove Communication"
        onClick={showDeleteModal}
      >
        <TrashIcon size={16} className="cell-icon" />
      </button>
    </div>
  );
};

CommunicationsAdminColumnRenderer.propTypes = {
  value: PropTypes.shape(messagePropTypes),
  rowIndex: PropTypes.number.isRequired,
  showModalForAddEdit: PropTypes.func.isRequired,
  showModalForRemove: PropTypes.func.isRequired,
};

export default connect(null, {
  showModalForAddEdit: sharedActions.showModalForAddEdit,
  showModalForRemove: sharedActions.showModalForRemove,
})(CommunicationsAdminColumnRenderer);
